/* Boost V2 — welcome popup (CRO-001) + exit-intent popup (CRO-002) */
(function(){
  'use strict';
  var Boost = window.Boost || (window.Boost = {});

  // ===== Welcome popup =====
  (function(){
    var pop = document.querySelector('[data-welcome-popup]');
    if (!pop) return;
    if (Boost.cookie.get('boost_welcome_seen') === '1' || Boost.cookie.get('boost_subscribed') === '1') return;
    var delay = parseInt(pop.dataset.delay || '10000', 10);
    if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
      var mobileDelay = parseInt(pop.dataset.delayMobile || '30000', 10);
      delay = Math.max(delay, mobileDelay);
    }
    setTimeout(function(){
      pop.classList.add('is-open');
      if (window.gtag) gtag('event','welcome_popup_shown');
    }, delay);

    pop.addEventListener('click', function(e){
      if (e.target.closest('[data-welcome-close]')) {
        pop.classList.remove('is-open');
        Boost.cookie.set('boost_welcome_seen', '1', 90);
      }
    });
    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(form);
      fd.append('form_type','customer');
      fd.append('utf8','✓');
      fd.append('contact[tags]','newsletter,welcome-popup');
      fetch('/contact', {method:'POST', body:fd, headers:{'X-Requested-With':'XMLHttpRequest'}}).finally(function(){
        var content = pop.querySelector('[data-welcome-content]');
        if (content) content.innerHTML = '<h3>Code on the way!</h3><p>Check your inbox in the next minute. Use it on your first order.</p>';
        Boost.cookie.set('boost_subscribed', '1', 365);
        if (window.gtag) gtag('event','email_signup_welcome_popup');
        setTimeout(function(){ pop.classList.remove('is-open'); }, 4000);
      });
    });
  }());

  // ===== Exit intent (desktop only) =====
  (function(){
    var overlay = document.querySelector('[data-exit-intent]');
    if (!overlay) return;
    if ('ontouchstart' in window) return;
    if (Boost.cookie.get('boost_exit_seen') === '1' || Boost.cookie.get('boost_subscribed') === '1') return;
    var fired = false;
    function trigger(){
      if (fired) return;
      fired = true;
      overlay.classList.add('is-open');
      Boost.cookie.set('boost_exit_seen', '1', 7);
      if (window.gtag) gtag('event','exit_intent_shown');
    }
    document.addEventListener('mouseleave', function(e){
      if (e.clientY < 0) trigger();
    });
    overlay.addEventListener('click', function(e){
      if (e.target.closest('[data-exit-close]') || e.target === overlay) {
        overlay.classList.remove('is-open');
      }
    });
    var form = overlay.querySelector('form');
    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(form);
      fd.append('form_type','customer');
      fd.append('utf8','✓');
      fd.append('contact[tags]','newsletter,exit-intent');
      fetch('/contact', {method:'POST', body:fd, headers:{'X-Requested-With':'XMLHttpRequest'}}).finally(function(){
        Boost.cookie.set('boost_subscribed', '1', 365);
        if (window.gtag) gtag('event','email_signup_exit_intent');
        overlay.classList.remove('is-open');
      });
    });
  }());
}());
